// src/utils/wsUrl.js
// Build a WebSocket URL that always targets the same origin as the page,
// so requests are proxied by whatever nginx/ingress is serving the app.
// This prevents cross-origin WebSocket failures when env vars or hardcoded
// defaults point at a remote backend (e.g. https://ojuimo.com) while the
// page is served from localhost or a different host.

export function sameOriginWs(path = '/') {
  if (typeof window === 'undefined' || !window.location) return path;
  const scheme = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  const host = window.location.host;
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${scheme}//${host}${p}`;
}

export default sameOriginWs;
